<p-table class="test-list Auto_Test_List" scrollHeight="20rem"
         [columns]="testColumnsToDisplay"
         [rows]="maxNumberOfDisplayedRows"
         [scrollable]="true"
         [totalRecords]="testsFormalize.length"
         [value]="testListToDisplay">
  <ng-template pTemplate="body" let-rowData>
    <tr class="{{getRowClasses(rowData)}}" (click)="openTest(rowData)">
      <td *ngFor="let testColumn of testColumnsToDisplay" class="{{testColumn.field}} property testType">
        <gen-test-list-item [testRow]="rowData" [testColumn]="testColumn"></gen-test-list-item>
      </td>
    </tr>
  </ng-template>
</p-table>
